import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  CssBaseline,
  TextField,
  Box,
  InputAdornment,
  IconButton,
  Typography
} from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import { getInternalLogo, getThemeIllustrations } from "../../services/theme-service";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: "100vh",
    overflow: "hidden",
  },
  leftColumn: {
    width: "100%",
    maxWidth: 420,
    backgroundColor: "#DDF0F8",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(4),
    zIndex: 2,
    paddingTop: 150,
  },
  rightColumn: {
    flexGrow: 1,
    position: "relative",
  },
  backgroundLayer: {
    position: "absolute",
    inset: 0,
    backgroundRepeat: "repeat",
    backgroundSize: "auto",
    backgroundPosition: "top left",
    opacity: 0.08, // Adjust opacity here
    zIndex: 0, // behind animationContainer (which is zIndex: 1)
    pointerEvents: "none", // prevent blocking interactions
  },
  formContainer: {
    width: "100%",
    maxWidth: 360,
  },
  logo: {
    height: 80,
    marginBottom: theme.spacing(3),
    filter: "drop-shadow(rgba(0, 118, 157, 1) 1px 1px 1px)",
  },
  form: {

    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  animationContainer: {
    position: "absolute",
    inset: 0,
    overflow: "hidden",
    zIndex: 1,
  },
  floatingImage: {
    position: "absolute",
    willChange: "transform, opacity",
    animationName: '$float',
    animationIterationCount: "infinite",
    animationTimingFunction: "ease-in-out",
    animationDirection: "alternate",
   
  },
  "@keyframes float": {
    "0%": {
      transform: "translateY(0px) translateX(0px) rotate(0deg)",
      opacity: 0.7,
    },
    "50%": {
      transform: "translateY(-25px) translateX(15px) rotate(5deg)",
      opacity: 1,
    },
    "100%": {
      transform: "translateY(0px) translateX(-15px) rotate(-5deg)",
      opacity: 0.7,
    },
  },
}));

const Login = () => {
  const classes = useStyles();
  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const { handleLogin } = useContext(AuthContext);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  useEffect(() => {
    const container = document.getElementById("animation-container");
    if (!container) return;

    container.innerHTML = "";

    // Carregar as ilustrações do tema atual
    const floatingImages = getThemeIllustrations();
    
    floatingImages.forEach((imgSrc) => {
      const img = document.createElement("img");
      img.src = imgSrc;
      img.className = classes.floatingImage;

      const size = Math.random() * 100 + 50;
      img.style.width = `${size}px`;
      img.style.height = "auto";
      img.style.top = `${Math.random() * (container.clientHeight - size)}px`;
      img.style.left = `${Math.random() * (container.clientWidth - size)}px`;
      img.style.animationDuration = `${Math.random() * 10 + 8}s`;
      img.style.animationDelay = `${Math.random() * 5}s`;

      container.appendChild(img);
    });
  }, [classes.floatingImage]);

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/* Left: Login form */}
      <div className={classes.leftColumn}>
        <div className={classes.formContainer}>
          <img src={getInternalLogo('logo-login.png')} alt="Logo" className={classes.logo} />
          <form className={classes.form} noValidate onSubmit={handlSubmit}>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label={i18n.t("login.form.email")}
              name="email"
              value={user.email}
              onChange={handleChangeInput}
              autoComplete="email"
              autoFocus
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label={i18n.t("login.form.password")}
              id="password"
              value={user.password}
              onChange={handleChangeInput}
              autoComplete="current-password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(prev => !prev)}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              {i18n.t("login.buttons.submit")}
            </Button>

          </form>
        </div>
        <Typography style={{ textAlign: "center", color: "#AAA", marginTop: "auto" }}>
          Powered by Nembi
        </Typography>
        <Box mt={8} />
      </div>

      {/* Right: Animated background */}
      <div className={classes.rightColumn}>
       { false && <div className={classes.backgroundLayer}></div> }
        <div id="animation-container" className={classes.animationContainer}></div>
      </div>
    </div>
  );
};

export default Login;
